<div class="content-card filters">
  <div class="top">
    <div class="top__left">
      <div fxLayout="row" fxLayoutAlign="space-between center">
        <div fxLayout="row" fxLayoutAlign="space-around center">
          <button mat-icon-button (click)="previousWeek()">
            <mat-icon>keyboard_arrow_left</mat-icon>
          </button>
          <div class="week-info" (click)="picker.open()">
            <div class="year-week">{{ currentDate | weekYear }} Tydzień {{ currentDate | week }}</div>
            <div class="week-range">{{ currentDate | weekRange }}</div>
          </div>
          <button mat-icon-button (click)="nextWeek()">
            <mat-icon>keyboard_arrow_right</mat-icon>
          </button>
          <div class="datepicker">
            <input matInput [matDatepicker]="picker" (dateChange)="onDateChange($event)" readonly />
            <mat-datepicker #picker></mat-datepicker>
          </div>
          <button mat-icon-button (click)="picker.open()">
            <mat-icon>event</mat-icon>
          </button>
        </div>
      </div>
    </div>
    <div class="top__right"></div>
  </div>
</div>
<div class="content-card table-container">
  <div class="table-wrapper custom-table">
    <mat-table #table matSort matSortActive="submissionDate" matSortDirection="desc" matSortDisableClear [dataSource]="dataSource">
      <ng-container matColumnDef="clientCode" [sticky]="screenService.isAboveMd$ | async">
        <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
          {{ 'Order.RealizationList.ClientCode' | translate }}
          <app-table-header-sort></app-table-header-sort>
        </mat-header-cell>
        <mat-cell *matCellDef="let element">{{ element.ClientCode }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="employerName">
        <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
          {{ 'Order.RealizationList.Employer' | translate }}
          <app-table-header-sort></app-table-header-sort>
        </mat-header-cell>
        <mat-cell *matCellDef="let element">{{ element.EmployerName }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="employerObjectName">
        <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
          {{ 'Order.RealizationList.EmployerObject' | translate }}
          <app-table-header-sort></app-table-header-sort>
        </mat-header-cell>
        <mat-cell *matCellDef="let element">{{ element.EmployerObjectName }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="positionExpectationName">
        <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
          {{ 'Order.RealizationList.PositionExpectation' | translate }}
          <app-table-header-sort></app-table-header-sort>
        </mat-header-cell>
        <mat-cell *matCellDef="let element">{{ element.PositionExpectationName }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="submissionDate">
        <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
          {{ 'Order.RealizationList.SubmissionDate' | translate }}
          <app-table-header-sort></app-table-header-sort>
        </mat-header-cell>
        <mat-cell *matCellDef="let element">{{ element.SubmissionDate | date : 'yyyy-MM-dd' }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="startDate">
        <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
          {{ 'Order.RealizationList.StartDate' | translate }}
          <app-table-header-sort></app-table-header-sort>
        </mat-header-cell>
        <mat-cell *matCellDef="let element">{{ element.StartDate | date : 'yyyy-MM-dd' }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="employeesNumber">
        <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
          {{ 'Order.RealizationList.EmployeesNumber' | translate }}
          <app-table-header-sort></app-table-header-sort>
        </mat-header-cell>
        <mat-cell *matCellDef="let element">{{ element.EmployeesNumber }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="realizationPeriodNumber">
        <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
          {{ 'Order.RealizationList.RealizationPeriodNumber' | translate }}
          <app-table-header-sort></app-table-header-sort>
        </mat-header-cell>
        <mat-cell class="realization-column" *matCellDef="let element">{{ element.RealizationPeriodNumber | percent : '1.2-2' }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="finalRealizationNumber">
        <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
          {{ 'Order.RealizationList.FinalRealizationNumber' | translate }}
          <app-table-header-sort></app-table-header-sort>
        </mat-header-cell>
        <mat-cell class="realization-column" *matCellDef="let element">{{ element.FinalRealizationNumber | percent : '1.2-2' }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="actions" stickyEnd>
        <mat-header-cell *matHeaderCellDef> {{ 'Actions' | translate }} </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <ng-container></ng-container>
          @if (screenService.isAboveMd$ | async) {
            @if (hasAnyAction(element)) {
              <button mat-button class="button-text" [matMenuTriggerFor]="menuRow">
                <mat-icon class="material-icons-outlined">more_vert</mat-icon>
              </button>
            }
          } @else {
            @if (hasAnyAction(element)) {
              <button mat-icon-button [matMenuTriggerFor]="menuRow">
                <mat-icon class="material-icons-outlined">more_vert</mat-icon>
              </button>
            }
          }


          <mat-menu #menuRow="matMenu" panelClass="actions-menu">
            @if (archiveButtonVisible(element.OrderItemStatusId)) {
              <button mat-button (click)="archiveOrderItem(element.OrderItemId)">
                <mat-icon>archive</mat-icon>
                <span class="button-text">{{ 'Order.List.ArchiveOrderItem' | translate }}</span>
              </button>
            }
          </mat-menu>
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
    </mat-table>
  </div>
</div>
<mat-paginator [length]="dataSource.count$ | async" [pageSize]="10" [pageSizeOptions]="[10, 15, 20]"></mat-paginator>
